import PropTypes from 'prop-types';

const intlShape = PropTypes.object;

export { intlShape };
